<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Event Detail
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.devent',
                label: dateTypeA(this.getDetailStats.devent),
                hint: 'event date',
                icon: 'today'
                }"
              />
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="found"
                :label="this.localForm.found"
                :items="asFoundConditionOptions"
                color="wplblue0"
                prepend-icon="local_fire_department"
                hint="as found condition"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">

          </v-layout>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Event Description
            </div>
            <v-spacer/>
            <div class="mr-4 mt-4">
              {{dateTimeAgo(this.getDetailStats.devent)}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2 mt-2">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.des"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="descibe, what happened and what you saw"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import eventOptions from "@/data/options/mixins/eventOptions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import DatePicker from "@/data/functions/components/DatePicker";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        des: "",
        found: ""
      },
      orgForm: {
        des: "",
        found: ""
      },
      found: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.des = this.getDetail.char.des;
    this.localForm.found = this.getDetail.char.found;
    this.localForm.event = this.getDetail.char.event;

    this.orgForm.des = this.getDetail.char.des;
    this.orgForm.event = this.getDetail.char.event;
    this.orgForm.found = this.getDetail.char.found;
  },
  watch: {
    found() {
      this.localForm.found = this.found;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    dateFunctions,
    eventOptions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailStats",
      "getCurrentPage"
    ])
  },
  components: {
    DatePicker
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line

      if (
        this.localForm.des !== this.orgForm.des &&
        this.localForm.des !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.des = this.localForm.des;
        // basic
        char.des = this.localForm.des;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.found !== this.orgForm.found &&
        this.localForm.found !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.found = this.localForm.found;
        // basic
        char.found = this.localForm.found;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
